import styled from 'styled-components';

export const SectionContainer = styled.div`
  background-color: #1a1a1a;
  width: 100%;

  @media (max-width: 768px) {
    padding: 40px 0 56px 0;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1369px;
  width: 100%;
  margin: 0 auto 80px auto;
  padding: 0 20px 10px 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    max-width: 340px;
    margin: 40px auto;
    padding: 0;
    gap: 40px;
  }
`;

export const FormContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-left: 60px;

  @media (max-width: 768px) {
    padding-left: 20px;
    padding-right: 20px;
  }

  h2 {
    font-size: 24px;
    font-weight: 300;
    line-height: 32px;
    margin-bottom: 20px;

    span {
      color: #f16024;
    }

    @media (max-width: 768px) {
      font-size: 20px;
      margin-bottom: 50px;
    }
  }

  div {
    display: flex;
    flex-direction: column;

    position: relative;
  }

  label {
    color: #e4e4e4;
    font-size: 16px;
    font-weight: 275;
    line-height: 24px;

    span {
      color: #f16024;
    }

    @media (max-width: 768px) {
      font-size: 14px;
      padding-left: 2px;
    }
  }

  input,
  textarea {
    background: #171717;
    border: 1px solid #252525;
    color: #fff;
    padding: 10px;
    border-radius: 2px;
    font-size: 16px;
    outline: none;
    min-width: 100%;
    margin-bottom: 5px;

    &:focus {
      border-color: #f16024;
    }

    @media (max-width: 768px) {
      min-width: 80%;
      height: 40px;
      font-size: 14px;
    }
  }

  textarea {
    resize: none;
    height: 100px;

    @media (max-width: 768px) {
      height: 120px;
    }
  }

  input,
  textarea::placeholder {
    font-family: 'Open Sans';
    font-size: 12px;
    font-weight: 300;
    line-height: 16px;

    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
`;

export const ErrorMessage = styled.span`
  color: #f16024;
  font-size: 14px;
  font-weight: 400;
  position: absolute;
  bottom: -20px;
  right: 0;
  display: block;
  text-align: right;
`;

export const ImageBox = styled.div`
  flex: 1;
  text-align: center;
  padding-left: 100px;

  @media (max-width: 768px) {
    padding-left: 0;
  }

  img {
    max-width: 100%;
    height: auto;
    mask-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0) 100%
    );
    -webkit-mask-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0) 100%
    );
  }
`;

export const SubmitButton = styled.button`
  background-color: #f16024;
  border: none;
  color: #fff;
  padding: 12px 20px;
  font-size: 18px;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s ease;
  width: 480px;
  min-width: 100%;
  margin-top: 30px;
  text-align: center;

  @media (max-width: 768px) {
    width: 330px;
    height: 36px;
    padding: 0;
  }

  &:hover {
    background-color: #d1491e;
  }

  &:disabled {
    background-color: #7a7a7a;
    cursor: not-allowed;
  }
`;

export const RecaptchaContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
`;
